import { t } from 'i18next';
import React, { useEffect } from 'react'
import Modal from 'react-modal';
import i18n from '../../i18n';
import { useSelector } from 'react-redux';
import { showInIQD } from '../../customFunction/Numeral/CurrencyFormat';
import { convertCurrency } from '../../store/actions/dollarPricesAction';

const customStyles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    top: '50%',
    left: '50%',
    right: 'auto',
    height: 'fit-content',
    width: '40%',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '4px',
    borderRadius: '0px',
    transform: 'translate(-50%, -50%)',
  },
};

function PriceCalculationModal({
  priceModal,
  onChangeModal,
  onChangeModalData,
  onSubmit,
  from,//!0 from packages, 1 from expenses, 2 from courses
}) {
  const currentDollarPrice = useSelector(state => state.dollarPrices.currentPrice.price);
  const onChangePayedType = (key, type) => {
    onChangeModalData({
      ...priceModal,
      [key]: type,
    })
  }

  const onChangeAmountByCustomer = (amount, type,) => {
    if (type === 0) {
      if (amount) {
        amount = Number(amount)
        // console.log(amount)
        onChangeModalData({
          ...priceModal, paymentDetails: {
            ...priceModal.paymentDetails,
            amountByCustomer: amount,
          }
        })
      }
    }
    else {
      //!dollar manually input but for dinar we automatically calculate it
      amount = Number(amount)
      const fourNumDollar = (currentDollarPrice + 1500 + '').substring(0, 4);
      let price = priceModal.data.price.value;


      let iqdAmount = ((price - amount) * (Number(fourNumDollar)));
      iqdAmount = Math.ceil(iqdAmount / 1000) * 1000

      onChangeModalData({
        ...priceModal, paymentDetails: {
          ...priceModal.paymentDetails,
          dollarAmount: amount,
          iqdAmount
        }
      })
    }
  }

  const calculateChangeAmount = (value) => {
    console.log({ value })
    if (!priceModal.paymentDetails.amountByCustomer) return
    //! dollar 
    if (priceModal.payedType === 0) {
      const fourNumDollar = (currentDollarPrice - 1000 + '').substring(0, 4);
      let price = priceModal.data.price.value
      const amountByCustomer = priceModal.paymentDetails.amountByCustomer;

      let changePrice = Math.ceil(((amountByCustomer - price) * fourNumDollar));
      if (priceModal.changeType === 0) {
        changePrice = Math.ceil(amountByCustomer - price);
      }

      if (priceModal.changeType === 1)
        // if (changePrice % 1000 > 500) {
        //   changePrice = Math.ceil(changePrice / 1000) * 1000;
        // } else {
        changePrice = Math.floor(changePrice / 1000) * 1000;
      // }
      if (priceModal.changeType === 2) {
        onChangeModalData({
          ...priceModal, paymentDetails: {
            ...priceModal.paymentDetails,
            dollarChange: Number(value),
            iqdChange: Math.floor(((Number(amountByCustomer) - Number(value) - price) * fourNumDollar) / 1000) * 1000
          }
        })
        return
      }

      onChangeModalData({
        ...priceModal, paymentDetails: {
          ...priceModal.paymentDetails,
          changePrice: changePrice
        }
      })
    } else if (priceModal.payedType === 1) {
      const fourNumDollar = (currentDollarPrice + 1500 + '').substring(0, 4);
      // console.log(fourNumDollar)
      let priceIqd

      if (from === 0) {
        priceIqd = Math.round(((priceModal.data.price.value * fourNumDollar)) / 1000) * 1000
      }

      const amountByCustomer = priceModal.paymentDetails.amountByCustomer;

      let changePrice = (((amountByCustomer - priceIqd)));
      if (priceModal.changeType === 1) {
        changePrice = Math.ceil(amountByCustomer - priceIqd);
      } else if (priceModal.changeType === 0) {
        changePrice = Math.floor(((amountByCustomer - priceIqd) / fourNumDollar))
      }

      if (priceModal.changeType !== 0)
        // if (changePrice % 1000 > 500) {
        //   changePrice = Math.ceil(changePrice / 1000) * 1000;
        // } else {
        changePrice = Math.floor(changePrice / 1000) * 1000;
      // }

      if (priceModal.changeType === 2) {
        onChangeModalData({
          ...priceModal, paymentDetails: {
            ...priceModal.paymentDetails,
            dollarChange: Number(value),
            iqdChange: Math.floor(((Number(amountByCustomer) - Number(value * fourNumDollar) - priceIqd)) / 1000) * 1000
          }
        })
        return
      }


      onChangeModalData({
        ...priceModal, paymentDetails: {
          ...priceModal.paymentDetails,
          changePrice: changePrice
        }
      })
    }
  }

  useEffect(() => {
    calculateChangeAmount()
  }, [priceModal.paymentDetails.amountByCustomer, priceModal.changeType])

  useEffect(() => {
    onChangeModalData({
      ...priceModal, paymentDetails: {
        ...priceModal.paymentDetails,
        changePrice: 0,
        amountByCustomer: 0
      }
    })
  }, [priceModal.payedType])

  const onValidation = () => {
    if (priceModal.data.price.value === 0 && priceModal.paymentDetails.amountByCustomer === 0) {
      onSubmit()
    } else if (priceModal.payedType !== 2 && !priceModal.paymentDetails.amountByCustomer) {
      alert('please enter dollar amount')
    } else if (priceModal.payedType === 2 && !priceModal.paymentDetails.dollarAmount) {
      alert('please enter dollar amount')
    } else if (priceModal.changeType !== 2 && priceModal.paymentDetails.changePrice < 0) {
      alert('please enter right amount')
    } else if (priceModal.changeType === 2 && (!priceModal.paymentDetails.iqdChange || priceModal.paymentDetails.iqdChange < 0 || !priceModal.paymentDetails.dollarChange || priceModal.paymentDetails.dollarChange < 0)) {
      alert('please enter dollar change amount')
    } else if (priceModal.changeType === 1 && priceModal.paymentDetails.changePrice > 150000) {
      alert('change amount is too much, please be sure of payed type')
    } else if (priceModal.changeType === 0 && priceModal.paymentDetails.changePrice > 200) {
      alert('change amount is too much, please be sure of payed type')
    } else {
      onSubmit()
    }
  }

  return (
    <div>
      <Modal
        isOpen={priceModal.show}
        onRequestClose={onChangeModal}
        style={customStyles}
      >
        <div className='flex flex-col w-full h-full py-4' style={{ direction: i18n.language === 'en' ? 'ltr' : 'rtl', fontFamily: i18n.language === 'en' ? 'Montserrat' : 'aka' }} >
          <div className='flex items-center justify-between w-full h-[50px] p-2  bg-black/5' >
            <p className='w-[55%] font-medium '  >{t('payedType')}</p>
            <div className='flex justify-between w-[45%]' >
              <div onClick={onChangePayedType.bind(this, 'payedType', 0)} className={`flex items-center justify-center p-1 px-4 ${priceModal.payedType === 0 ? 'bg-green-400 text-white' : ''}  cursor-pointer`} >
                {t('dollar')}
              </div>
              <div onClick={onChangePayedType.bind(this, 'payedType', 1)} className={`p-2  bg-green-400 ${priceModal.payedType === 1 ? 'bg-green-400 text-white' : 'bg-transparent'} cursor-pointer`}>
                {t('iqd')}
              </div>
              <div onClick={onChangePayedType.bind(this, 'payedType', 2)} className={`p-2  bg-green-400 ${priceModal.payedType === 2 ? 'bg-green-400 text-white' : 'bg-transparent'} cursor-pointer`}>
                {t('both')}
              </div>
            </div>
          </div>
          {<>
            <div className='flex items-center justify-between h-[50px] w-full p-2 my-4  bg-black/5' >
              <p className='w-1/2 font-medium '  >{t('totalPrice')}</p>
              <p className='font-bold' >{priceModal.payedType === 0 ? showInIQD(priceModal?.data?.price?.value, 'USD') : priceModal.payedType === 1 ? convertCurrency(priceModal?.data?.price?.value, 'IQD') : showInIQD(priceModal?.data?.price?.value, 'USD') + ' - ' + convertCurrency(priceModal?.data?.price?.value, 'IQD')}</p>
            </div>
            <div className='flex items-center  justify-between h-[50px] w-full p-2 mb-4  bg-black/5' >
              <p className='font-medium w-[45%] break-words'  >{t('amountOfPaymentByCustomer')}</p>
              <>
                {priceModal.payedType === 2 ? <>
                  <input type='number' value={priceModal?.paymentDetails?.dollarAmount} onChange={e => onChangeAmountByCustomer(e.target.value, 1, 'dollarAmount')} className='p-2 bg-white w-[35%] outline-none mx-2' placeholder={t('dollar')} />
                  <input disabled type='number' value={priceModal?.paymentDetails?.iqdAmount} className='p-2 bg-white w-[35%] outline-none' placeholder={t('iqd')} />
                </> : <>
                  <input type='number' value={priceModal?.paymentDetails?.amountByCustomer} onChange={e => onChangeAmountByCustomer(e.target.value, 0)} className='p-2 bg-white w-[35%] outline-none' placeholder={priceModal.payedType === 0 ? t('dollar') : t('iqd')} />
                </>}
              </>
            </div>
            {priceModal.payedType !== 2 && <>
              <div className='flex items-center justify-between w-full h-[50px] mb-4 p-2  bg-black/5' >
                <p className='w-[55%] font-medium '  >{t('changeType')}</p>
                <div className='flex justify-between w-[45%]' >
                  <div onClick={onChangePayedType.bind(this, 'changeType', 0)} className={`flex items-center justify-center p-1 px-4 ${priceModal?.changeType === 0 ? 'bg-green-400 text-white' : ''}  cursor-pointer`} >
                    {t('dollar')}
                  </div>
                  <div onClick={onChangePayedType.bind(this, 'changeType', 1)} className={`p-2  bg-green-400 ${priceModal?.changeType === 1 ? 'bg-green-400 text-white' : 'bg-transparent'} cursor-pointer`}>
                    {t('iqd')}
                  </div>
                  <div onClick={onChangePayedType.bind(this, 'changeType', 2)} className={`p-2  bg-green-400 ${priceModal?.changeType === 2 ? 'bg-green-400 text-white' : 'bg-transparent'} cursor-pointer`}>
                    {t('both')}
                  </div>
                </div>
              </div>
              <div className='flex items-center  justify-between h-[50px] w-full p-2 mb-4  bg-black/5' >
                <p className='font-medium w-[65%]'>{t('changeAmount')}</p>
                <>
                  {priceModal.changeType === 2 ? <>
                    <input type='number' value={priceModal?.paymentDetails?.dollarChange} onChange={e => calculateChangeAmount(e.target.value)} className='p-2 bg-white w-[35%] outline-none mx-2' placeholder={t('dollar')} />
                    <input disabled type='number' value={priceModal?.paymentDetails?.iqdChange} className='p-2 bg-white w-[35%] outline-none' placeholder={t('iqd')} />
                  </> : <p className='font-medium w-[35%] text-end'>{priceModal?.paymentDetails?.changePrice}</p>}

                </>
              </div>
            </>}
            <div onClick={onValidation} className='flex self-center p-3 bg-blue-500 cursor-pointer w-fit' >
              <p className='font-medium  text-white w-[65%]'  >{t('submit')}</p>
            </div>
          </>}
        </div>
      </Modal>
    </div>
  )
}

export default PriceCalculationModal
